/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Manage_MenuInputs */

const en_speakers_manage_menu = /** @type {(inputs: Speakers_Manage_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Speakers`)
};

const fr_speakers_manage_menu = /** @type {(inputs: Speakers_Manage_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Speakers`)
};

const de_speakers_manage_menu = /** @type {(inputs: Speakers_Manage_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Speakers`)
};

const it_speakers_manage_menu = /** @type {(inputs: Speakers_Manage_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Speakers`)
};

const ru_speakers_manage_menu = /** @type {(inputs: Speakers_Manage_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Speakers`)
};

const es_speakers_manage_menu = /** @type {(inputs: Speakers_Manage_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Speakers`)
};

const zh_cn2_speakers_manage_menu = /** @type {(inputs: Speakers_Manage_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Speakers`)
};

const ja_speakers_manage_menu = /** @type {(inputs: Speakers_Manage_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Speakers`)
};

const hi_speakers_manage_menu = /** @type {(inputs: Speakers_Manage_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Speakers`)
};

const pt_pt2_speakers_manage_menu = /** @type {(inputs: Speakers_Manage_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Speakers`)
};

/**
* | output |
* | --- |
* | "Manage Speakers" |
*
* @param {Speakers_Manage_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_manage_menu = /** @type {((inputs?: Speakers_Manage_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Manage_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_manage_menu(inputs)
	if (locale === "de") return de_speakers_manage_menu(inputs)
	if (locale === "it") return it_speakers_manage_menu(inputs)
	if (locale === "ru") return ru_speakers_manage_menu(inputs)
	if (locale === "es") return es_speakers_manage_menu(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_manage_menu(inputs)
	if (locale === "ja") return ja_speakers_manage_menu(inputs)
	if (locale === "hi") return hi_speakers_manage_menu(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_manage_menu(inputs)
	return en_speakers_manage_menu(inputs)
});